module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cdfa6cb"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/Logout.vue
// module id = 2665
// module chunks = 0